export default function directiveService() {
    const listeners = [];
    return {
        subscribe(callback) {
            listeners.push(callback);
        },
        publish(msg) {
            angular.forEach(listeners, (value) => {
                value(msg);
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/services/directiveService.js